export { default as DeniedAccess } from "./DeniedAccess";
